import React from "react";
import "./style.scss";

export default function AppHeader() {
  return (
    <div className="app-header">
      <div className="app-left">
        <span></span>
        <i className="vop_font"></i>
      </div>
      <div className="app-right">
        <a href="/">返回VOP首页</a>
      </div>
    </div>
  );
}
